import Button from '@atlaskit/button';
import { css } from '@emotion/core';
import React, { useContext } from 'react';

import { Theme, ThemeContext } from '@/controllers';

import { OneSightLogoDark } from './onesight-logo-dark';
import { OneSightLogoLight } from './onesight-logo-light';

interface OneSightLinkProps {
  orgId: string;
}

const buttonStyles = css`
  margin-right: 4px;
  column-gap: 3px;
`;

const ONESIGHT_BASE_URL = 'https://onesight.prod-east.frontend.public.atl-paas.net';

const OnesightLink = ({ orgId }: OneSightLinkProps) => {
  const [theme] = useContext(ThemeContext);
  const OnesightLogo = theme === Theme.Dark ? OneSightLogoDark : OneSightLogoLight;

  return (
    <Button
      iconBefore={<OnesightLogo />}
      href={`${ONESIGHT_BASE_URL}/team/${orgId}/page/f4de9c41-642f-48ed-b6d1-29814cf88ff7/metric/OSDM-1/detail`}
      target="_blank"
      css={buttonStyles}
    >
      SLO Attainment
    </Button>
  );
};

export default OnesightLink;
